/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Logout_viewer$ref = any;
type SideNav_viewer$ref = any;
type Wishlist_viewer$ref = any;
export type routes_Wishlist_QueryVariables = {||};
export type routes_Wishlist_QueryResponse = {|
  +viewer: ?{|
    +salesNumber: ?string,
    +wishlist: ?{|
      +id: string,
      +products: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: ?string,
            +price: ?number,
            +sku: ?string,
            +brand: ?{|
              +id: string,
              +name: ?string,
            |},
            +mainImage: ?{|
              +id: string,
              +url: ?string,
              +thumbnail: ?string,
            |},
            +type: ?string,
            +urlSlug: ?string,
            +fullUrl: ?string,
            +sellable: ?boolean,
            +nonStock: ?boolean,
            +freeShipping: ?boolean,
            +inStoreOnly: ?boolean,
            +preorderDate: ?string,
            +backInStockDate: ?string,
            +model: ?string,
            +clearance: ?boolean,
            +callForPrice: ?boolean,
            +configurables: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +name: ?string,
                  +price: ?number,
                |}
              |}>
            |},
            +labels: ?{|
              +edges: ?$ReadOnlyArray<?{|
                +node: ?{|
                  +id: string,
                  +imageUrl: ?string,
                  +placement: ?string,
                |}
              |}>
            |},
          |}
        |}>
      |},
    |},
    +email: ?string,
    +$fragmentRefs: Wishlist_viewer$ref & SideNav_viewer$ref & Logout_viewer$ref,
  |}
|};
export type routes_Wishlist_Query = {|
  variables: routes_Wishlist_QueryVariables,
  response: routes_Wishlist_QueryResponse,
|};
*/


/*
query routes_Wishlist_Query {
  viewer {
    ...Wishlist_viewer
    salesNumber
    wishlist {
      id
      products(first: 999) {
        edges {
          node {
            id
            name
            price
            sku
            brand {
              id
              name
            }
            mainImage {
              id
              url
              thumbnail
            }
            type
            urlSlug
            fullUrl
            sellable
            nonStock
            freeShipping
            inStoreOnly
            preorderDate
            backInStockDate
            model
            clearance
            callForPrice
            configurables(first: 99) {
              edges {
                node {
                  id
                  name
                  price
                }
              }
            }
            labels(first: 999) {
              edges {
                node {
                  id
                  imageUrl
                  placement
                }
              }
            }
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
    ...SideNav_viewer
    email
    ...Logout_viewer
    id
  }
}

fragment Logout_viewer on Customer {
  email
}

fragment SideNav_viewer on Customer {
  email
  ...Logout_viewer
}

fragment Wishlist_viewer on Customer {
  salesNumber
  wishlist {
    id
    products(first: 999) {
      edges {
        node {
          id
          name
          price
          sku
          brand {
            id
            name
          }
          mainImage {
            id
            url
            thumbnail
          }
          type
          urlSlug
          fullUrl
          sellable
          nonStock
          freeShipping
          inStoreOnly
          preorderDate
          backInStockDate
          model
          clearance
          callForPrice
          configurables(first: 99) {
            edges {
              node {
                id
                name
                price
              }
            }
          }
          labels(first: 999) {
            edges {
              node {
                id
                imageUrl
                placement
              }
            }
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesNumber",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 999
  }
],
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sku",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Brand",
            "kind": "LinkedField",
            "name": "brand",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductImage",
            "kind": "LinkedField",
            "name": "mainImage",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbnail",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urlSlug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fullUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sellable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nonStock",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "freeShipping",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inStoreOnly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "preorderDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backInStockDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "model",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clearance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "callForPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 99
              }
            ],
            "concreteType": "ProductConnection",
            "kind": "LinkedField",
            "name": "configurables",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "configurables(first:99)"
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "LabelConnection",
            "kind": "LinkedField",
            "name": "labels",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LabelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Label",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "placement",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "labels(first:999)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_Wishlist_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Wishlist",
            "kind": "LinkedField",
            "name": "wishlist",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": "products",
                "args": null,
                "concreteType": "ProductConnection",
                "kind": "LinkedField",
                "name": "__Wishlist_products_connection",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Wishlist_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SideNav_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Logout_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "routes_Wishlist_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Wishlist",
            "kind": "LinkedField",
            "name": "wishlist",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "ProductConnection",
                "kind": "LinkedField",
                "name": "products",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": "products(first:999)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Wishlist_products",
                "kind": "LinkedHandle",
                "name": "products"
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51a0a7ff80905fbec3b19822d860995d",
    "id": null,
    "metadata": {},
    "name": "routes_Wishlist_Query",
    "operationKind": "query",
    "text": "query routes_Wishlist_Query {\n  viewer {\n    ...Wishlist_viewer\n    salesNumber\n    wishlist {\n      id\n      products(first: 999) {\n        edges {\n          node {\n            id\n            name\n            price\n            sku\n            brand {\n              id\n              name\n            }\n            mainImage {\n              id\n              url\n              thumbnail\n            }\n            type\n            urlSlug\n            fullUrl\n            sellable\n            nonStock\n            freeShipping\n            inStoreOnly\n            preorderDate\n            backInStockDate\n            model\n            clearance\n            callForPrice\n            configurables(first: 99) {\n              edges {\n                node {\n                  id\n                  name\n                  price\n                }\n              }\n            }\n            labels(first: 999) {\n              edges {\n                node {\n                  id\n                  imageUrl\n                  placement\n                }\n              }\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    ...SideNav_viewer\n    email\n    ...Logout_viewer\n    id\n  }\n}\n\nfragment Logout_viewer on Customer {\n  email\n}\n\nfragment SideNav_viewer on Customer {\n  email\n  ...Logout_viewer\n}\n\nfragment Wishlist_viewer on Customer {\n  salesNumber\n  wishlist {\n    id\n    products(first: 999) {\n      edges {\n        node {\n          id\n          name\n          price\n          sku\n          brand {\n            id\n            name\n          }\n          mainImage {\n            id\n            url\n            thumbnail\n          }\n          type\n          urlSlug\n          fullUrl\n          sellable\n          nonStock\n          freeShipping\n          inStoreOnly\n          preorderDate\n          backInStockDate\n          model\n          clearance\n          callForPrice\n          configurables(first: 99) {\n            edges {\n              node {\n                id\n                name\n                price\n              }\n            }\n          }\n          labels(first: 999) {\n            edges {\n              node {\n                id\n                imageUrl\n                placement\n              }\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6e4071f7b78d433e2c8ceaae6cb0bb51';

module.exports = node;
